import React from 'react';

// Generic tool icon for message badges
const ToolIcon = () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
        <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const ChatMessages = ({ messages }) => {
    if (!messages || messages.length === 0) return null;

    const formatTime = (timestamp) => {
        if (!timestamp) return '';
        const date = new Date(timestamp);
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    const formatContent = (content) => {
        if (!content) return '';

        // Simple markdown-like formatting
        return content
            .split('\n')
            .map((line, i) => {
                // Bold text
                line = line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
                // Bullet points
                if (line.startsWith('- ') || line.startsWith('• ')) {
                    return `<li key="${i}">${line.substring(2)}</li>`;
                }
                // Numbered lists
                if (/^\d+\.\s/.test(line)) {
                    return `<li key="${i}">${line.replace(/^\d+\.\s/, '')}</li>`;
                }
                return line;
            })
            .join('<br/>');
    };

    return (
        <div className="clarence-messages">
            {messages.map((msg, idx) => (
                <div key={idx} className={`clarence-message clarence-message-${msg['role']}`}>
                    {msg['role'] === 'assistant' && (
                        <div className="clarence-message-avatar">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#6366f1"/>
                                <path d="M12 6v6l4 2" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </div>
                    )}
                    <div className="clarence-message-content">
                        <div className="clarence-message-text" dangerouslySetInnerHTML={{ __html: formatContent(msg['content']) }} />
                        {msg['sources'] && msg['sources'].length > 0 && (
                            <div className="clarence-message-sources">
                                <span className="sources-label">Sources:</span>
                                {msg['sources'].map((source, i) => (
                                    <a key={i} href={source} target="_blank" rel="noopener noreferrer" className="source-link">
                                        {source.split('/').pop()}
                                    </a>
                                ))}
                            </div>
                        )}
                        {msg['role'] === 'assistant' && msg['toolsUsed'] && msg['toolsUsed'].length > 0 && (
                            <div className="message-tools-used">
                                <span className="message-tools-label">Tools used:</span>
                                <div className="message-tools-badges">
                                    {msg['toolsUsed'].map((tool, i) => (
                                        <span key={i} className="message-tool-badge">
                                            <ToolIcon />
                                            {tool['displayName'] || tool['name']}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        )}
                        <span className="clarence-message-time">{formatTime(msg['timestamp'])}</span>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ChatMessages;
